import { render } from "./LeadsLinkAccountDialog.vue?vue&type=template&id=8fae3e16"
import script from "./LeadsLinkAccountDialog.vue?vue&type=script&lang=js"
export * from "./LeadsLinkAccountDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__